import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { tasksService } from '../api/tasks.service';
import { TASK_KEYS } from './queryKeys';

export function useTaskAttachments(taskId: string | null) {
  const activeOrganizationId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useQuery({
    queryKey: TASK_KEYS.attachments(activeOrganizationId, taskId ?? ''),
    queryFn: ({ signal }) => tasksService.listAttachments(taskId!, signal),
    staleTime: 60_000,
    enabled: !!activeOrganizationId && !!taskId,
  });
}
